import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const SchoolConfirmation = () => {

  const [isVisible, setIsVisible] = useState(false);
  const school = useSelector(state => state.school);

  useEffect(() => {
    if (sessionStorage.getItem("school") === school.code) return;
    setIsVisible(true);
  }, [school]);

  const closeModal = () => {
    sessionStorage.setItem("school", school.code);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="modal">
      <div className="modal_cont">
        <div className="schoolConfirmation">
          <strong>{school?.cityName}{school?.name}</strong>입니다.<br />
          계속하시겠습니까?
        </div>
        <div className="button-wrapper">
          <Link to={`/`} className="btn _white">학교선택</Link>
          <button className="btn _blue wide" onClick={closeModal}>계속하기</button>
        </div>
      </div>
    </div>
  );

};